import { TelegramProvider } from '@/app/providers/TelegramProvider';
import { QueryProvider } from '@/app/providers/QueryProvider';
import { AppRouter } from '@/app/router';
import '@telegram-apps/telegram-ui/dist/styles.css';

export function App() {
  return (
    <TelegramProvider>
      <QueryProvider>
        <AppRouter />
      </QueryProvider>
    </TelegramProvider>
  );
}
